export function serializeParams(params: Record<string, any>): string {
  const parts: string[] = [];

  const build = (value: any, key: string) => {
    if (value === null || value === undefined) {
      return;
    }
    // Array => key[index]=item
    if (Array.isArray(value)) {
      value.forEach((v, i) => {
        build(v, `${key}[${i}]`);
      });
    }
    // Object => key[subKey]=subValue
    else if (typeof value === "object") {
      Object.keys(value).forEach((subKey) => {
        build(value[subKey], `${key}[${subKey}]`);
      });
    }
    // Primitive => key=value
    else {
      parts.push(`${key}=${value}`);
    }
  };

  Object.keys(params).forEach((key) => {
    build(params[key], key);
  });

  return parts.join("&");
}
